import { render, staticRenderFns } from "./msTrV2.vue?vue&type=template&id=5cc2a5d9&scoped=true"
import script from "./msTrV2.vue?vue&type=script&lang=js"
export * from "./msTrV2.vue?vue&type=script&lang=js"
import style0 from "./msTrV2.vue?vue&type=style&index=0&id=5cc2a5d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc2a5d9",
  null
  
)

export default component.exports